import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { requests } from "../../common/RestAPI";

import { base64Encoding, checkFormatAllow, getUUID } from "../../common/util";
import { LOCALSTORAGE, SESSIONSTORAGE } from "../../value/staticValues";
import { PAGE_URL, PLATFORM_URL } from "../../value/Url";

import Login from "./Login";

export default function LoginContainer() {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [alartText, setAlartText] = useState('');
    const [isCapsLockOn, setIsCapsLockOn] = useState(false);
    const [idSaveCheck, setIdSaveCheck] = useState(false);
    const [loginStatus, setLoginStatus] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        ReadIdFunction();

        window.addEventListener("keyup", detectCapsLock);
        return () => {
            window.removeEventListener("keyup", detectCapsLock);
        };
    }, [])


    useEffect(() => {
        if(isCapsLockOn) {
            setAlartText(t('CASPLOCK_ON_ALERT'))
        }
        else {
            setAlartText('')
        }
        if(searchParams.get('err_sts')){
            if(searchParams.get('err_sts') === "change") {
                setAlartText(t("LOGIN_DUPLICATE_ERROR_MESSAGE"));
            } else if(searchParams.get('err_sts') === "long") {
                setAlartText(t("LOGIN_LONGTIME_ERROR_MESSAGE"));
            }
        }
    }, [searchParams, isCapsLockOn])


    function ReadIdFunction() {
        const rememberId = localStorage.getItem(LOCALSTORAGE.REMEMBER_ID);
        if (rememberId) {
            setEmail(rememberId);
            setIdSaveCheck(true);
        }
    }

    function getUserAgent() {
        let browser, device, ipAddr;
        let userAgent = navigator.userAgent.toLowerCase();
        if(userAgent.indexOf("firefox") > -1) browser = "Firefox";
        else if(userAgent.indexOf("edge") > -1) browser = "MSEdge";
        else if(userAgent.indexOf("chrome") > -1) browser = "Chrome";
        else if(userAgent.indexOf("safari") > -1) browser = "Safari";
        else if(userAgent.indexOf("msie") > -1) browser = "MSIE";
        else if(userAgent.indexOf("samsung") > -1) browser = "SamsungBrowser";
        else if(userAgent.indexOf("opera") > -1 || userAgent.indexOf("OPR") > -1) browser = "Opera";
        else browser = "Unknown";

        device = navigator.platform + "-" + getUUID();
        ipAddr = "0.0.0.0";

        return {agentBrowser: browser, agentDevice: device, ipAddr: ipAddr};
    }


    function detectCapsLock(e: KeyboardEvent) {
        if (e && e.getModifierState && e.getModifierState("CapsLock")) {
            setIsCapsLockOn(true);
        } else {
            setIsCapsLockOn(false);
        }
    }

    function loginBtnClick() {
        setAlartText('');
        setLoginStatus(true);

        if (!email) {
            setLoginStatus(false);
            setAlartText(t("LOGIN_EMAIL_INPUT_EMPTY_ERROR_MESSAGE"));
            return;
        }
        else if(!checkFormatAllow(email,["email"])) {
            setLoginStatus(false);
            setAlartText(t("LOGIN_EMAIL_INPUT_FORMAT_ERROR_MESSAGE"));
            return;
        }
        else if (!password) {
            setLoginStatus(false);
            setAlartText(t("LOGIN_PASSWORD_INPUT_EMPTY_ERROR_MESSAGE"));
            return;
        }

        if(idSaveCheck) {
            localStorage.setItem(LOCALSTORAGE.REMEMBER_ID, email);
        }
        else {
            localStorage.removeItem(LOCALSTORAGE.REMEMBER_ID);
        }

        const userAgent = getUserAgent();

        const body = {
            email: email,
            password: password,
            device: userAgent.agentBrowser
        };

        requests.post(PLATFORM_URL.LOGIN, body)
        .then((response) => {
            if (response.status === 200 && response.data) {
                if(response.data.change_password_yn) {
                    // 임시 비밀번호를 사용한 로그인
                    sessionStorage.setItem(SESSIONSTORAGE.USER_ID, base64Encoding(response.data.user_id));
                    sessionStorage.setItem(SESSIONSTORAGE.API_KEY, base64Encoding(response.data.access_token));
                    navigate(`${PAGE_URL.CHANGEPWD}`);
                } else {
                    // 정상 로그인
                    try{
                    sessionStorage.setItem(SESSIONSTORAGE.USER_ID, base64Encoding(response.data.user_id));
                    sessionStorage.setItem(SESSIONSTORAGE.USER_NAME, base64Encoding(response.data.alias));
                    sessionStorage.setItem(SESSIONSTORAGE.USER_EMAIL, base64Encoding(response.data.email));
                    sessionStorage.setItem(SESSIONSTORAGE.USER_FULLNAME, base64Encoding(response.data.fullname));
                    sessionStorage.setItem(SESSIONSTORAGE.API_KEY, base64Encoding(response.data.access_token));
                    sessionStorage.setItem(SESSIONSTORAGE.RSH_KEY, base64Encoding(response.data.refresh_token));
                    sessionStorage.setItem(SESSIONSTORAGE.USER_ROLE, base64Encoding(response.data.user_role_type_code));
                    sessionStorage.setItem(SESSIONSTORAGE.PROJECT_ROLE, base64Encoding(response.data.project_role_type_code));
                    sessionStorage.setItem(SESSIONSTORAGE.USER_COMPANY_NAME, base64Encoding(response.data.company_name));
                    sessionStorage.setItem(SESSIONSTORAGE.PHONE_NUMBER, base64Encoding(response.data.phone_number));
                    sessionStorage.setItem(SESSIONSTORAGE.DEPARTMENT_NAME, base64Encoding(response.data.department_name));
                    sessionStorage.setItem(SESSIONSTORAGE.DEPARTMENT_RANK, base64Encoding(response.data.department_rank));
                    sessionStorage.setItem(SESSIONSTORAGE.PROJECT_ID, base64Encoding(response.data.proejct?.proejct_id));
                    sessionStorage.setItem(SESSIONSTORAGE.PROJECT_NAME, base64Encoding(response.data.project?.proejct_name));
                    sessionStorage.setItem(SESSIONSTORAGE.FIRST_LOGIN, base64Encoding(response.data.first_login_yn));
                    sessionStorage.setItem(SESSIONSTORAGE.EMAIL_YN, base64Encoding(response.data.email_notify_yn));
                    sessionStorage.setItem(SESSIONSTORAGE.SMS_YN, base64Encoding(response.data.sms_notify_yn));
                    sessionStorage.setItem(SESSIONSTORAGE.USER_STATUS_CODE, base64Encoding(response.data.user_status_code));
                    } catch(e) {
                        console.log(e)
                    }
                    navigate(`${PAGE_URL.DASHBOARD}`);
                }
            } else {
                setAlartText(t("LOGIN_BLOCK_ERROR_MESSAGE"));
            }
        })
        .catch((e) => {

            if (e.headers?.error_code === 'LOGIN_BLK') {
                setAlartText(t("LOGIN_BLOCK_ERROR_MESSAGE"));
            } else if (e.headers?.error_code === 'ACCNT_DACT') {
                setAlartText(t("LOGIN_DISABLED_ERROR_MESSAGE"));
            } else if (e.headers?.error_code === 'LOGIN_FAIL') {
                setAlartText(t("LOGIN_NOT_FOUND_ERROR_MESSAGE"));
            } else {
                setAlartText(t("LOGIN_FAIL_MESSAGE"));
            }

            setLoginStatus(false);
        });
    }

    return (
        <Login
            loginBtnClick={loginBtnClick}
            loginStatus={loginStatus}
            email={email}
            setEmail={setEmail}
            setPassword={setPassword}
            setIdSaveCheck={setIdSaveCheck}
            idSaveCheck={idSaveCheck}
            alartText={alartText}
            navigate={navigate}
        />
    )
}